/**
 * The valid values for a free busy type for a calendar item
 */
export type FreeBusyType =
    | 'Free'
    | 'Busy'
    | 'Tentative'
    | 'OOF'
    | 'WorkingElsewhere'
    | 'NoData'
    | 'Loading'
    | 'NoInformation';

/**
 * Constants to use for comparing to the FreeBusyType
 */
let FreeBusyConstants = {
    Free: 'Free',
    Busy: 'Busy',
    Tentative: 'Tentative',
    OOF: 'OOF',
    WorkingElsewhere: 'WorkingElsewhere',
    NoData: 'NoData',
    Loading: 'Loading',
    NoInformation: 'NoInformation',
};

export default FreeBusyConstants;
